import { Component, Input, OnInit, Output, EventEmitter, HostListener, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { BasePaths, MemberPaths } from "src/app/constants/routes";
import { FormValidationService } from "src/app/services/form-validation.service";
import { LoginPayload, MemberAuthorizationResult, MultiMemberSelectResult } from "src/app/models/member";
import { AuthService } from "src/app/services/auth.service";
import { SessionService } from "src/app/services/storage/session.service";
import { AdminDirectSystemLocation } from "src/app/constants/admin-direct-system";
import { LoginType } from "src/app/constants/login-type";
import { ToastService } from "src/app/services/toast.service";
import { ToastType } from "src/app/constants/toast-type";
import { AuthenticatorInfo, MultiFactorAuthenticator } from "src/app/models/authenticator";
import { HelperService } from "src/app/services/helper.service";


@Component({
    selector: 'mwp-login-form',
    templateUrl: './login-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginFormComponent implements OnInit {
    @Input() public LoginType: LoginType;
    @Output() public emitMultiFactorAuthenticator: EventEmitter<MultiFactorAuthenticator> = new EventEmitter();
    @Output() public emitBaseMemberSession: EventEmitter<MultiMemberSelectResult> = new EventEmitter();

    public loginForm: FormGroup;
    public route = BasePaths;
    public androidURL = environment.androidURL;
    public appleURL = environment.appleURL;
    public adminDirectSystemLocation = AdminDirectSystemLocation;
    public reCaptchaTokenId: string = "reCaptchaTokenId";
    public reCaptchaToken: string = "reCaptchaToken"; 
    public useSecondaryCaptcha: boolean;

    @HostListener('window:keydown.enter', ['$event']) onEnter(e: Event): void {
        if (e instanceof KeyboardEvent)
            e.preventDefault();

        if (this.loginForm.valid)
            this.submitLogIn();
        e.preventDefault();
    }

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private authService: AuthService,
        private sessionService: SessionService,
        private toast: ToastService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.useSecondaryCaptcha = this.sessionService.session.operatingMode.useSecondaryCaptcha;
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            email: [null, [Validators.required, Validators.compose([FormValidationService.validEmail(true)])]],
            password: [null, Validators.required],
            [this.reCaptchaTokenId]: [null],
            [this.reCaptchaToken]: [null, [Validators.required]],
        });
    }

    public submitLogIn(): void {
        // Security: Simple Bot bypass form validation prevention
        if (!this.loginForm.get(this.reCaptchaToken).value)
            return;

        const l_Payload = new LoginPayload();
        l_Payload.username = this.loginForm.get('email').value;
        l_Payload.password = this.loginForm.get('password').value;
        if (l_Payload.password.length < 8 || l_Payload.password.length > 20) {
            return this.toast.buildToastMessage(ToastType.error, 'Error', 'Invalid Email or Password. Please try again.');
        }

        if (this.LoginType == LoginType.FirstResponder && this.sessionService.session.isFirstResponder) {
            l_Payload.comCode = this.sessionService.session.firstResponderComCode;
        }

        l_Payload.reCaptchaID = this.loginForm.get(this.reCaptchaTokenId).value;
        l_Payload.reCaptchaToken = this.loginForm.get(this.reCaptchaToken).value;
        l_Payload.pyid = sessionStorage.getItem('PY_ID');
        this.authService.memberLogin(l_Payload).subscribe((response: MemberAuthorizationResult) => {
            if (response.isMemberAutoLoggedIn) {
                if (response.members[0].pyidMatchedMember == true) {
                    this.router.navigateByUrl(MemberPaths.PayrollPayStubs)
                } else {
                    sessionStorage.getItem('PY_ID');
                    this.router.navigateByUrl(MemberPaths.Dashboard);
                }
            } else {
                const l_MultiMemberAuthorization: MultiMemberSelectResult = new MultiMemberSelectResult();
                l_MultiMemberAuthorization.reCaptchaID = l_Payload.reCaptchaID;
                l_MultiMemberAuthorization.reCaptchaToken = l_Payload.reCaptchaToken;
                l_MultiMemberAuthorization.members = response.members;
                this.emitBaseMemberSession.emit(l_MultiMemberAuthorization);
            }
            // const l_MultiFactorAuthenticator: MultiFactorAuthenticator = this.helperService.convertObjectIntoObject(response, new MultiFactorAuthenticator());
            // l_MultiFactorAuthenticator.isMember = true;
            // this.emitMultiFactorAuthenticator.emit(l_MultiFactorAuthenticator);
        });
    }

    public reloadCaptcha(useSecondary: boolean): void {
        this.useSecondaryCaptcha = useSecondary;
        this.sessionService.session.operatingMode.useSecondaryCaptcha = useSecondary;
        this.sessionService.setSession();
    }
}